var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_3185863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.79 16.09c-13.45-18.41-42.4-12.38-47.79 9.37l-3.23-6.19a2 2 0 0 0 -3.54 1.87l6.22 11.79a2 2 0 0 0 2.21 1 4.24 4.24 0 0 0 .5-.18l11.84-6.2a2 2 0 0 0 -1.92-3.55l-8.6 4.54c3-19.93 29-26.54 41.08-10.09 11.11 14.82.09 36.59-18.45 36.43a22.73 22.73 0 0 1 -13.54-4.44 2 2 0 1 0 -2.37 3.22 26.62 26.62 0 0 0 15.91 5.22c21.78.19 34.73-25.38 21.68-42.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.16f1c69f5e50b2b152b92e8da6308a67.svg";
export { ForwardRef as ReactComponent };